import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import Fa from 'react-fontawesome';
import { withRouter, Switch, Route } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { NavItem } from 'react-bootstrap';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import ConversionRatesPage from '../ConversionRates/ConversionRatesPage';
import InactiveStageMappingPage from '../InactiveStageMappingPage/InactiveStageMappingPage';
import CRMInstanceName from '../../../../components/crm-instance-name';


class SalesStagePage extends Component {
  constructor() {
    super();
    this.state = {};
  }

  renderSyncButton() {
    return (
      <span>
        <button
          type="button"
          className="btn btn-sm btn-default"
          onClick={this.requestSyncStages}
        >
          <Fa name="refresh" /> Sync stages with <CRMInstanceName />
        </button>
      </span>
    );
  }

  renderInstruction() {
    return (
      <div className="well well-sm">
        <div>
          <p>
            Configure sales stages to include/exclude and the order of sales stages.
            Conversion rates will be used the Pipeline view.
          </p>
        </div>
      </div>
    );
  }

  render() {
    const { location, organization } = this.props;
    const isDemo = organization && organization.is_demo;
    return (
      <div>
        <Helmet title="Sales Stage Setup" />
        <div className="container">
          {!isDemo && this.renderInstruction()}
          {isDemo &&
            <div className="alert alert-warning">
              This is a demo organization, please switch back to the original organization to change the conversion rates setup.
            </div>
          }
          <ul className="nav nav-tabs">
            <LinkContainer exact to="/setup/sales-stages">
              <NavItem>Active Stages</NavItem>
            </LinkContainer>
            <LinkContainer exact to="/setup/sales-stages/inactive-stages">
              <NavItem>Inactive Stages</NavItem>
            </LinkContainer>
          </ul>
          <p />
        </div>
        {!isDemo &&
          <Switch>
            <Route exact path="/setup/sales-stages" component={ConversionRatesPage} />
            <Route path="/setup/sales-stages/inactive-stages" component={InactiveStageMappingPage} />
          </Switch>
        }
      </div>
    );
  }
}

SalesStagePage.propTypes = {
  organization: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};

function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

export default connect(mapStateToProps)(withRouter(SalesStagePage));

